<template>
  <ExamAnalysis :path="'/byl'"></ExamAnalysis>
</template>

<script>
  import ExamAnalysis from '@/page/modules/exam/analysis'
  export default {
    components: { ExamAnalysis },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/byl/exam/analysis.vue